module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"titles_with_most_interest":"Highest interest of this type","no_matching_titles":"Nothing with this type of interest"},"cs":{"titles_with_most_interest":"Největší zájem tohoto typu","no_matching_titles":"Pro tento typ zájmu nejsou žádné záznamy"}}')
  delete Component.options._Ctor
}
